import React, { memo, useMemo } from 'react';
import { CBody } from '@modules/common/CBody';
import { PageHeader } from '@modules/common';
import { Container } from 'reactstrap';
import { Tabs, TabsMapping } from '@modules/common/Tabs/Tabs';
import { PayablesList } from './PayablesList/PayablesList';
import { BillsList } from './BillsList/BillsList';
import { useRouteParams } from '@core/router';

export const PayablesPage = memo(() => {
  const tabsMapping: TabsMapping[] = useMemo(
    () => [
      {
        title: 'Payables',
        component: PayablesList,
        leftIcon: 'bx bx-list-ul',
        props: { card: true },
        route: 'payables',
      },
      {
        title: 'Bills',
        component: BillsList,
        leftIcon: 'bx bx-receipt',
        route: 'bills',
      },
    ],
    [],
  );

  const activeTabIndex = useMemo(() => {
    const wind = window.location.pathname;
    const foundIndex = tabsMapping.findIndex(t => wind.includes(t.route || ''));
    return foundIndex === -1 ? 0 : foundIndex;
  }, [tabsMapping]);

  return (
    <div className="page-content">
      <Container fluid>
        <PageHeader>Payables & Bills</PageHeader>
        <Tabs tabs={tabsMapping} routeParam="tab" route={tab => `/${tab}`} isLazy={true} initialIndex={activeTabIndex} />
      </Container>
    </div>
  );
});
